'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _kepler = require('kepler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var activityTable = function (_React$Component) {
  _inherits(activityTable, _React$Component);

  function activityTable(props) {
    _classCallCheck(this, activityTable);

    var _this = _possibleConstructorReturn(this, (activityTable.__proto__ || Object.getPrototypeOf(activityTable)).call(this, props));

    _this.state = {
      transactions: _this.props.transactions ? _this.props.transactions : []
    };
    return _this;
  }

  _createClass(activityTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        transactions: nextProps.transactions
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var activityMsg = this.props.activityMsg;
      var flowType = this.props.flowType;
      var renderActivityTable = this.state.transactions.map(function (result, index) {
        return _react2.default.createElement(
          'tbody',
          { key: index },
          _react2.default.createElement(
            'tr',
            { className: result.campaign_title || result.item_id || result.donatedDate ? 'campaignAvailable' : '' },
            _react2.default.createElement(
              'td',
              null,
              result.date + ' ' + result.month + ' ' + result.year
            ),
            _react2.default.createElement(
              'td',
              null,
              result.donor_name
            ),
            _react2.default.createElement(
              'td',
              { className: 'wordbreak' },
              result.donor_email_address
            ),
            flowType === 'common' && _react2.default.createElement(
              'td',
              null,
              result.partner_name
            ),
            _react2.default.createElement(
              'td',
              null,
              result.payout_description,
              ' ',
              result.campaign_title || result.item_id || result.donatedDate ? _react2.default.createElement('i', { className: 'icon icon-arrow-down-small' }) : ''
            ),
            _react2.default.createElement(
              'td',
              null,
              function () {
                var transactionType = result.transaction_type.toString();
                switch (transactionType) {
                  case '1':
                    return _react2.default.createElement(
                      'span',
                      { className: 'neg' },
                      result.payout_amount
                    );
                  case '2':
                    return _react2.default.createElement(
                      'span',
                      { className: 'neg' },
                      result.payout_amount
                    );
                  default:
                    return _react2.default.createElement(
                      'span',
                      { className: 'pos' },
                      result.payout_amount
                    );
                }
              }()
            )
          ),
          _react2.default.createElement(
            'tr',
            { className: 'transSubDetails' },
            _react2.default.createElement(
              'td',
              { colSpan: '3', className: 'campaignInfo' },
              result.campaign_title ? _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  activityMsg.campaigntitle
                ),
                ' ',
                result.campaign_title,
                ' '
              ) : '',
              result.item_id ? _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  activityMsg.ebaylistingid
                ),
                ' ',
                result.item_id,
                ' '
              ) : '',
              result.donatedDate ? _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  activityMsg.donationDate
                ),
                ' ',
                result.donatedDate,
                ' '
              ) : ''
            ),
            _react2.default.createElement('td', { colSpan: '3' })
          )
        );
      });
      return _react2.default.createElement(
        'div',
        { id: 'activityResult' },
        _react2.default.createElement(
          _kepler.Table,
          { id: 'activityTable' },
          _react2.default.createElement(
            'colgroup',
            null,
            _react2.default.createElement('col', { width: '10%' }),
            _react2.default.createElement('col', { width: '15%' }),
            _react2.default.createElement('col', { width: '20%' }),
            flowType === 'common' && _react2.default.createElement('col', { width: '15%' }),
            _react2.default.createElement('col', { width: '30%' }),
            _react2.default.createElement('col', { width: '10%' })
          ),
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { id: 'date' },
                activityMsg.payoutdate
              ),
              _react2.default.createElement(
                'th',
                null,
                activityMsg.donorname
              ),
              _react2.default.createElement(
                'th',
                null,
                activityMsg.email
              ),
              flowType === 'common' && _react2.default.createElement(
                'th',
                null,
                activityMsg.partner
              ),
              _react2.default.createElement(
                'th',
                null,
                activityMsg.program
              ),
              _react2.default.createElement(
                'th',
                { id: 'amount' },
                activityMsg.amount
              )
            )
          ),
          renderActivityTable.length > 0 ? renderActivityTable : _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                { colSpan: flowType === 'common' ? '6' : '5', className: 'colspan-align-center' },
                activityMsg.norecordsfound
              )
            )
          )
        )
      );
    }
  }]);

  return activityTable;
}(_react2.default.Component);

activityTable.propTypes = {
  transactions: _react.PropTypes.array,
  pageNo: _react.PropTypes.number,
  activityMsg: _react.PropTypes.object,
  gettingsnewTransactions: _react.PropTypes.func,
  flowType: _react.PropTypes.string
};

exports.default = activityTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/ppgf-components/dist/components/activityTable.js
// module id = 501
// module chunks = 0